/* eslint-disable local/no-raw-colors */
import React from 'react'
import type { SvgProps } from 'react-native-svg'
import { ClipPath, Defs, G, Path, Rect, Svg } from 'react-native-svg'

export const AirportContacts: React.FC<SvgProps> = props => (
    <Svg viewBox='0 0 40 40' {...props}>
        <Rect x='0.5' y='0.5' rx='19.5' stroke='#E5E5E6' />
        <G clipPath='url(#clip0_4099_4514)'>
            <Path
                d='M28 12H12C10.9 12 10.01 12.9 10.01 14L10 26C10 27.1 10.9 28 12 28H28C29.1 28 30 27.1 30 26V14C30 12.9 29.1 12 28 12ZM28 26H12V16L20 21L28 16V26ZM20 19L12 14H28L20 19Z'
                fill='#E5E5E6'
            />
        </G>
        <Defs>
            <ClipPath id='clip0_4099_4514'>
                <Rect fill='white' transform='translate(8 8)' />
            </ClipPath>
        </Defs>
    </Svg>
)
